import React from 'react'
import {Redirect} from 'react-router-dom'
import {isEmpty} from 'lodash'

import auth from '../../stores/auth.js'
import errors from '../../lib/errors.js'
import ErrorDialog from '../UI/ErrorDialog'
import EditUser from './EditUser'
import BackButton from '../UI/BackButton'
import UserNotFound from './UserNotFound'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
const UserStore = Resource('users')

class MyAccountPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      user: {},
      error: '',
      redirect: '',
      loading: true
    }
  }

  componentDidMount() {
    const currentUser = auth.user()
    UserStore.find(currentUser.id)
    .then((result) => this.setState({user: result.data, loading: false}))
    .catch((error) => this.setState({
      user: {},
      error: errors.unpack(error),
      loading: false
    }))
  }

  _closeErrorDialog = () => this.setState({error: ''})

  _redirectTo = (url) => this.setState({redirect: url})

  _returnToDashboard = () => setTimeout(() => this._redirectTo('/'), 500)

  render() {
    const {
      user,
      error,
      loading,
      redirect
    } = this.state

    if (redirect) return <Redirect push to={redirect}/>
    if (loading) return <LinearLoader />
    if (isEmpty(user)) return <UserNotFound/>

    return (
      <section>
        <header>
          <PageTitle>
            My account
          </PageTitle>
        </header>

        <EditUser
          user={user}
          savedCallback={this._returnToDashboard}
          myAccount
        />
        <br/>
        <BackButton/>

        <ErrorDialog
          open={Boolean(error)}
          closeCallback={this._closeErrorDialog}>
          <p>
            <strong>Error:</strong> {error}
          </p>
        </ErrorDialog>
      </section>
    )
  }

}

export default MyAccountPage



// WEBPACK FOOTER //
// ./src/components/Users/MyAccountPage.jsx